import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Spin, Upload, message, Select, Input, Radio, Popover } from 'antd';
import { CloseCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import stdApplyJobModalStroke from '../../public/img/std/stdApplyJobModalStroke.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import exports from '../../public/img/std/export.png';
import tag1 from '../../public/img/tag/tag1.png';
import saveImg from '../../public/img/newMain/Save.png';
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'

import './stdApplyJobModal.css'
import MessageSubmit from '../../component/messageSubmit/messageSubmit';

const { Option } = Select;
const { TextArea } = Input;
const ContractClauseTextModal = (props) => {
    const messageRef = useRef();
    const [isLoad, setIsLoad] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [jobPostModel, setJobPostModel] = useState(props.jobPostModel)
    const [checked, setChecked] = useState('SELECT');
    const [form] = Form.useForm();
    const [studentModel, setStudentModel] = useState({});
    const [documentFileList, setDocumentFileList] = useState([]);
    const [documentTwoFileList, setDocumentTwoFileList] = useState([]);
    const [documentThreeFileList, setDocumentThreeFileList] = useState([]);
    const [documentFourFileList, setDocumentFourFileList] = useState([]);
    const [resumeFileList, setResumeFileList] = useState([]);
    const resumeType = Form.useWatch('resumeType', form);
    const [fileTypeList, setFileTypeList] = useState([])
    const [flag, setFlag] = useState(false)
    const [fileSize, setFileSize] = useState('');

    useEffect(() => {
        searchFileSize()
        searchFileType()
        searchById(Config.studentInfo?.studentId)
        jobPostModel?.jobApplAnnexModelList.map((item, index) => {
            if (index === 0) {
                form.setFieldValue('fileTypeOne', item.fileType)
                setDocumentFileList([
                    {
                        uid: item.jobApplAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.jobApplFiles + item.storagePath,
                        status: 'old'
                    }
                ])
            }
            if (index === 1) {
                form.setFieldValue('fileTypeTwo', item.fileType)
                setDocumentTwoFileList([
                    {
                        uid: item.jobApplAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.jobApplFiles + item.storagePath,
                        status: 'old'
                    }
                ])
            }
            if (index === 2) {
                form.setFieldValue('fileTypeThree', item.fileType)
                setDocumentThreeFileList([
                    {
                        uid: item.jobApplAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.jobApplFiles + item.storagePath,
                        status: 'old'
                    }
                ])
            }
            if (index === 3) {
                form.setFieldValue('fileTypeFour', item.fileType)
                setDocumentFourFileList([
                    {
                        uid: item.jobApplAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.jobApplFiles + item.storagePath,
                        status: 'old'
                    }
                ])
            }
        })
        if (jobPostModel.resumeType === 'UPLOAD') {
            setResumeFileList([
                {
                    name: jobPostModel.annexName,
                    path: jobPostModel.storagePath,
                    url: Config.jobApplFiles + jobPostModel.storagePath,
                    status: 'old'
                }
            ])
            form.setFieldValue("resumeFileList", jobPostModel.storagePath)
        }
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchFileType = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "FILE_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setFileTypeList(list ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const searchById = (studentId) => {
        Base.callBackApi("studentInfo/searchById", {'studentId': studentId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setStudentModel(model)
                initForm(model);
            } else {
                message.error(data.msg)
            }
        })
    }

    const initForm = (model = {}) => {
        let studentAnnexId;
        model?.studentAnnexModelList?.map(item => {
            if (jobPostModel.storagePath === item.storagePath) {
                studentAnnexId = item.studentAnnexId
            }
        })
        // form.resetFields();
        form.setFieldsValue({
            resumeType: jobPostModel.resumeType ?? "SELECT",
            studentAnnexId: studentAnnexId ?? model?.studentAnnexModelList?.[0]?.studentAnnexId,
            portfolioLinkOne: jobPostModel.portfolioLinkOne ?? "",
            portfolioLinkOneDesc: jobPostModel.portfolioLinkOneDesc ?? "",
            portfolioLinkTwo: jobPostModel.portfolioLinkTwo ?? "",
            portfolioLinkTwoDesc: jobPostModel.portfolioLinkTwoDesc ?? "",
            portfolioLinkThree: jobPostModel.portfolioLinkThree ?? "",
            portfolioLinkThreeDesc: jobPostModel.portfolioLinkThreeDesc ?? "",
            additionalInfo: jobPostModel.additionalInfo ?? "",
            whatsApp: model?.whatsApp ?? '',
            weChat: model?.weChat ?? '',
            linkedIn: model?.linkedIn ?? '',
            personalWeb: model?.personalWeb ?? ''
        });
    }

    const options = [
        {
            label: 'Select from uploaded resume',
            value: 'SELECT',
        },
        {
            label: 'Upload (Maximum size per file ' + fileSize + 'MB)',
            value: 'UPLOAD',
        },
    ];

    const onChange = (checkedValues) => {
        setChecked(checkedValues.target.value);
    };

    const draft = () => {
        setFlag('draft')
        form.submit();
    }

    const apply = () => {
        setFlag("apply");
        messageRef.current.setContent('Please be cautious when sharing personal data. Avoid providing sensitive information or unnecessary data.')
        messageRef.current.setIsShow(true)
    }

    const done = (flag) => {
        if(flag) {
            form.submit()
        }
        messageRef.current.setIsShow(false)
    }

    const onFinish = (jobApplModel) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let formData = new FormData();
        let fileTypes = [jobApplModel.fileTypeOne, jobApplModel.fileTypeTwo, jobApplModel.fileTypeThree, jobApplModel.fileTypeFour]
        let jobApplAnnexModelList = []
        for (let i = 0; i < 4; i++) {
            let fileList = []
            if (i === 0) {
                fileList = documentFileList
            }
            if (i === 1) {
                fileList = documentTwoFileList
            }
            if (i === 2) {
                fileList = documentThreeFileList
            }
            if (i === 3) {
                fileList = documentFourFileList
            }
            let annexModel = {};
            for (let file of fileList) {
                annexModel.fileType = fileTypes[i]
                if (file.status != undefined && file.status != 'old') {
                    formData.append('files', file.originFileObj);
                } else {
                    annexModel.jobApplAnnexId = file.uid
                }
            }
            jobApplAnnexModelList[i] = annexModel
        }
        for (let file of resumeFileList) {
            if (file.status != undefined && file.status != 'old') {
                formData.append('resumeFile', file.originFileObj);
            } else {
                jobApplModel.annexName = file.name
                jobApplModel.storagePath = file.path
            }
        }
        jobApplModel.studentModuleId = studentModel.studentId
        jobApplModel.jobApplId = jobPostModel.jobApplId
        jobApplModel.jobId = jobPostModel.jobId
        jobApplModel.progCode = jobPostModel.progCode
        jobApplModel.lastUpdatedDate = jobPostModel.lastUpdatedDate
        jobApplModel.jobApplAnnexModelList = jobApplAnnexModelList
        formData.append("model", JSON.stringify(jobApplModel));
        let url = ''
        if (flag === 'apply') {
            jobPostModel.jobApplStatus === 'DRAFT' ? url = "studentJob/applyByDraft" : url = "studentJob/reapplyJob"
        } else if (flag === 'draft') {
            url = "studentJob/updateDraft"
        }
        Base.callBackUploadApi(url, formData).then((data) => {
            if ("SUCCESS" === data.msg) {
                props.onClose(true, data.object, flag);
            } else {
                message.error(data.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    const deleteTwoFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentTwoFileList));
        newList.splice(index, 1);
        setDocumentTwoFileList(newList);
    }
    const deleteThreeFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentThreeFileList));
        newList.splice(index, 1);
        setDocumentThreeFileList(newList);
    }
    const deleteFourFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFourFileList(newList);
    }

    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const handleDocumentTwoChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentTwoFileList(newFileList);
            return;
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentTwoFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const handleDocumentThreeChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentThreeFileList(newFileList);
            return;
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentThreeFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }
    const handleDocumentFourChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFourFileList(newFileList);
            return;
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setDocumentFourFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const beforeResumeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 4) {
            message.error('You can only upload four file.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    const deleteResumeFile = (index) => {
        let newList = JSON.parse(JSON.stringify(resumeFileList));
        newList.splice(index, 1);
        setResumeFileList(newList);
        form.setFieldValue('resumeFileList', null)
    }

    const handleResumeChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 10MB
            // 检查文件大小
            if (file.size > maxSize) {
                message.error('File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setResumeFileList(newFileList);
            return;
        } else if (file.status === "error") {
            message.error(file.error.message);
        } else if (file?.response?.error) {
            message.error(file.response.error?.message);
        }
        setResumeFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const beforeUpload = (file) => {
        // 检查当前已上传文件数量
        if (documentFileList.length >= 4) {
            message.error('You can upload up to 4 files.');
            return false; // 阻止上传
        }
        return true; // 允许上传
    };

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='1064px'//弹框宽度
            footer={false}
        >
            <div className='stdApplyJobModal'>
                <MessageSubmit ref={messageRef} done={done} />
                <Spin size="large" spinning={isLoad} >
                    <div className='titleBox'>
                        <div>
                            <div className='stdApplyJobModalTitle'>
                                {jobPostModel.jobTitle} Position
                            </div>
                            <div className='TitleTow'>
                                <div> @{jobPostModel.companyName} Inc.</div>
                                <div className='TitleTowRight'> Job ID #{jobPostModel.jobId}</div>
                            </div>
                        </div>
                        <img src={Config.studentInfo?.studentPhoto ? Config.studentPhotoImg + Config.studentInfo?.studentPhoto + '?' + Config.sasToken : studentDefaultPictureImg} />
                    </div>
                    <Form form={form} onFinish={onFinish}>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Student ID</div>
                                <div className="websiteSysInput">
                                    {studentModel?.studentAcctId}
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Student Name</div>
                                <div className="websiteSysInput">
                                    {studentModel?.firstName + ' ' + studentModel?.lastName}
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Programme Enrolled</div>
                                <div className="websiteSysInput">
                                    {Config?.studentInfo?.progTitle}
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Email</div>
                                <div className="websiteSysInput">
                                    {studentModel?.email}
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Contact Phone</div>
                                <div className="websiteSysInput">
                                    {studentModel?.contactPhone}
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">WhatsApp</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="whatsApp"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Wechat</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="weChat"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">LinkedIn</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="linkedIn"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Personal Web</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="personalWeb"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">
                                    <div className="mustFill">
                                        Resume
                                    </div>
                                    <Popover placement="bottom" content={
                                        <div>
                                            To load files onto the web system: <br></br>
                                            - Use only PDF, Word, or JPG file types. No video files allowed.<br></br>
                                            - Mind the file size limit.<br></br>
                                            - Store videos separately on e.g. Panopto (https://vtc.ap.panopto.com/).<br></br>
                                            {"- Insert the video's public URL link in your PDF or Word file."}<br></br>
                                            - Exercise caution and avoid sharing sensitive personal information in the uploaded files.
                                        </div>
                                    } trigger="hover" >
                                        <div className='questionCircle' style={{ marginLeft: '10px', color: '#000' }} ><QuestionCircleOutlined /></div>
                                    </Popover>
                                </div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="resumeType"
                                        rules={[
                                            { require: true, message: 'Resume is required.' }
                                        ]}
                                    >
                                        <Radio.Group
                                            style={{ display: 'flex', flexDirection: 'column' }}
                                            options={options}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Uploaded Resume</div>
                                {resumeType === 'UPLOAD' ?
                                    <div className="websiteSysInput ">
                                        <Form.Item
                                            name="resumeFileList"
                                            rules={[
                                                { required: true, message: 'Uploaded Resume is required.' }
                                            ]}
                                        >
                                            <div className='uploadBox'>
                                                <div className="uploadDocumentsBox" >
                                                    {resumeFileList.map((item, index) =>
                                                        <div className="uploadFileRow" key={index} title={item.name}>
                                                            <img src={tag1} className="tagImg"></img>
                                                            <div className='textEllipsis'>{item.name}</div>
                                                            <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteResumeFile(index)} />
                                                        </div>
                                                    )}
                                                </div>
                                                <Upload
                                                    maxCount={1}
                                                    action={Config.uploadTestServer}
                                                    key={"1"}
                                                    accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                                    fileList={resumeFileList}
                                                    onChange={(file) => handleResumeChange(file)}
                                                    showUploadList={false}>
                                                    <img src={exports} className='uploadButton' />
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </div>
                                    :
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="studentAnnexId"
                                            rules={[
                                                { required: true, message: 'Uploaded Resume is required.' }
                                            ]}
                                        >
                                            <Select className='sysSelect'>
                                                <Option value=""></Option>
                                                {studentModel?.studentAnnexModelList?.map(item => <Option key={item.studentAnnexId} value={item.studentAnnexId}>{item.annexName}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Additional Document 1 (Maximum file size is {fileSize}MB)</div>
                                <div className="websiteSysInput uploadBox">
                                    <div className="uploadDocumentsBox" >
                                        {documentFileList.map((item, index) =>
                                            <div className="uploadFileRow" key={index} title={item.name}>
                                                <img src={tag1} className="tagImg"></img>
                                                <div className='textEllipsis'>{item.name}</div>
                                                <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFile(index)} />
                                            </div>
                                        )}
                                    </div>
                                    <Upload
                                        maxCount={1}
                                        action={Config.uploadTestServer}
                                        key={"1"}
                                        accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                        fileList={documentFileList}
                                        onChange={(file) => handleDocumentChange(file)}
                                        showUploadList={false}>
                                        <img src={exports} className='uploadButton' />
                                    </Upload>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Document 1 Type</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="fileTypeOne"
                                    >
                                        <Select className='sysSelect'>
                                            <Option value=""></Option>
                                            {fileTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Additional Document 2 (Maximum file size is {fileSize}MB)</div>
                                <div className="websiteSysInput uploadBox">
                                    <div className="uploadDocumentsBox" >
                                        {documentTwoFileList.map((item, index) =>
                                            <div className="uploadFileRow" key={index} title={item.name}>
                                                <img src={tag1} className="tagImg"></img>
                                                <div className='textEllipsis'>{item.name}</div>
                                                <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteTwoFile(index)} />
                                            </div>
                                        )}
                                    </div>
                                    <Upload
                                        maxCount={1}
                                        action={Config.uploadTestServer}
                                        key={"1"}
                                        accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                        fileList={documentTwoFileList}
                                        onChange={(file) => handleDocumentTwoChange(file)}
                                        showUploadList={false}>
                                        <img src={exports} className='uploadButton' />
                                    </Upload>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Document 2 Type</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="fileTypeTwo"
                                    >
                                        <Select className='sysSelect'>
                                            <Option value=""></Option>
                                            {fileTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Additional Document 3 (Maximum file size is {fileSize}MB)</div>
                                <div className="websiteSysInput uploadBox">
                                    <div className="uploadDocumentsBox" >
                                        {documentThreeFileList.map((item, index) =>
                                            <div className="uploadFileRow" key={index} title={item.name}>
                                                <img src={tag1} className="tagImg"></img>
                                                <div className='textEllipsis'>{item.name}</div>
                                                <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteThreeFile(index)} />
                                            </div>
                                        )}
                                    </div>
                                    <Upload
                                        maxCount={1}
                                        action={Config.uploadTestServer}
                                        key={"1"}
                                        accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                        fileList={documentThreeFileList}
                                        onChange={(file) => handleDocumentThreeChange(file)}
                                        showUploadList={false}>
                                        <img src={exports} className='uploadButton' />
                                    </Upload>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Document 3 Type</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="fileTypeThree"
                                    >
                                        <Select className='sysSelect'>
                                            <Option value=""></Option>
                                            {fileTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Additional Document 4 (Maximum file size is {fileSize}MB)</div>
                                <div className="websiteSysInput uploadBox">
                                    <div className="uploadDocumentsBox" >
                                        {documentFourFileList.map((item, index) =>
                                            <div className="uploadFileRow" key={index} title={item.name}>
                                                <img src={tag1} className="tagImg"></img>
                                                <div className='textEllipsis'>{item.name}</div>
                                                <CloseCircleOutlined className='deleteFileButton' title='Delete File' onClick={() => deleteFourFile(index)} />
                                            </div>
                                        )}
                                    </div>
                                    <Upload
                                        maxCount={1}
                                        action={Config.uploadTestServer}
                                        key={"1"}
                                        accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                        fileList={documentFourFileList}
                                        onChange={(file) => handleDocumentFourChange(file)}
                                        showUploadList={false}>
                                        <img src={exports} className='uploadButton' />
                                    </Upload>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Document 4 Type</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="fileTypeFour"
                                    >
                                        <Select className='sysSelect'>
                                            <Option value=""></Option>
                                            {fileTypeList.map((item) => <Option key={item.paramId} value={item.paramId}>{item.parmValue1}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Portfolio Link 1</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkOne"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Description for Link 1</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkOneDesc"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Portfolio Link 2</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkTwo"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Description for Link 2</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkTwoDesc"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysRow'>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Portfolio Link 3</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkThree"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='websiteSysCol'>
                                <div className="websiteSysParam">Description for Link 3</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="portfolioLinkThreeDesc"
                                    >
                                        <Input className="stdApplyJobInputs" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="createJobPostingRow">
                            <div className="createJobPostingCol">
                                <div className='optionalTitle'>
                                    (Optional) Send comment to Industry Partner along with your job application
                                </div>
                                <div className="jobInput">
                                    <Form.Item
                                        name="additionalInfo"
                                    >
                                        <TextArea className='textArea' maxLength={1000} rows={3} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="saveButtonBox">
                        {jobPostModel.jobApplStatus === 'DRAFT' && <div className='draftButton' onClick={() => draft()}><img src={saveImg} />Save as Draft</div>}
                        <div className='submitButton' onClick={() => apply()}><img src={stdApplyJobAdd} />Submit to MC</div>
                        <div className='submitButtonTow' onClick={() => props.onClose(false)}><img src={stdApplyJobModalStroke} />Cancel</div>
                    </div>
                </Spin>
            </div>

        </Modal>
    )
}

ContractClauseTextModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    jobPostModel: PropTypes.object.isRequired,
}
export default ContractClauseTextModal;